/*
 * MAIN SCRIPT
 * DON'T WRITE FUNCTION HERE, ONLY CALL THEM
 *
 * **/
// document event listeners
const cardsAnimationTiming = 400;
document.addEventListener('DOMContentLoaded', (event) => {
    const formValidation = new FormsValidation();
    formValidation.initFormsValidation();
    initModalResponse();
    initLoadMore();
    initFilter();
    initVideo();
    initToggler();
    initCardComponent();
    initPaginationComponent();
    initCardListTextCta();
    initFadeInAnimations();
    initBigSliderHeading();
    initGallery();
    initSidebar();
    initWallPaperCardDeckWidget();
    initFormsExternalScripts();
});
